import React from 'react';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { ITransactionDto } from 'gen/ApiClient';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, ITransactionDto> {}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
